<template>
  <div ref="chart" style="width: 100%; height: 300px"></div>
</template>

<script>
import { GoogleCharts } from "google-charts";
// import firebase from "firebase";
// import db from "@/main.js";
// import { ref } from "vue";

export default {
  name: "BarChart",
  components: {
    // GoogleCharts,
  },
  props: {
    text: {
      type: String,
      default: "hello world",
    },
    data: {
      type: Object,
      default: () => ({}),
    },
  },
  mounted() {
    window.addEventListener("resize", this.redrawChart);

    GoogleCharts.load(() => {
      const data = GoogleCharts.api.visualization.arrayToDataTable(this.data);

      // [
      //   ["Year", "Sales", "Expenses"],
      //   ["2019", 1000, 400],
      //   ["2020", 1170, 460],
      //   ["2021", 660, 1120],
      //   ["2022", 1030, 540],
      // ]

      const options = {
        curveType: "function",
        legend: "none",
        colors: ["#721cff"],
        backgroundColor: { fill: "transparent" },
        vAxis: {
          viewWindow: {
            min: 0,
          },
          minorGridlines: {
            color: "transparent",
          },
          majorGridlines: {
            color: "#e0e0e0", // Major gridline color
          },
        },
        hAxis: {
          gridlines: {
            color: "transparent", // removes vertical lines
          },
        },
      };

      const chart = new GoogleCharts.api.visualization.ColumnChart(
        this.$refs.chart
      );

      chart.draw(data, options);
    });
  },
  methods: {
    redrawChart() {
      if (this.chart && this.dataTable) {
        this.chart.draw(this.dataTable, this.options);
      }
    },
  },
  setup() {
    return {};
  },
  data() {
    return {};
  },
  beforeUnmount() {
    window.removeEventListener("resize", this.redrawChart);
  },
};
</script>

<style></style>
